//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/NXObject.js";
let d=[[],[[["numTemplateVariants"],"GetTemplateVariants",{R_:{templateVariants:"NXObject[]"}},0,0],[["numValueSets"],"GetValueSets",{R_:{valueSets:"NXObject[]"}},0,0],[["templateInstanceAndValueSetGoupId"],"GetTemplateInstanceOfId",{R_:{templateInstance:"NXObject"}},1,0],[["templateInstanceAndValueSetGoupId","templateInstance"],"GetValueSetGroup",{R_:{valueSetGroup:"NXObject"}},2,0],[[],"GenerateValueSetReport",{},0,0]],[]];
SPLM.AME.Project = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.Project";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;